import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
import { hasCommentingFeature, hasDeepCommentingFeature } from '../utils/features';
import useCollaborationSidebarState from './useCollaborationSidebarState';
export default function useHasCommentingFeature() {
  "use memo";

  const $ = _c(2);
  const {
    enabledFeatures
  } = useCollaborationSidebarState();
  let t0;
  if ($[0] !== enabledFeatures) {
    t0 = hasCommentingFeature(enabledFeatures);
    $[0] = enabledFeatures;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export const useHasDeepCommentingFeature = () => {
  "use memo";

  const $ = _c(2);
  const {
    enabledFeatures
  } = useCollaborationSidebarState();
  let t0;
  if ($[0] !== enabledFeatures) {
    t0 = hasDeepCommentingFeature(enabledFeatures);
    $[0] = enabledFeatures;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};